export default {
    meta: {
        title: '拓店宝-门店交房',
    }
};
